module.exports = __webpack_public_path__ + "assets/img/package-man-old.5448f9ac.svg";